module.exports = __webpack_public_path__ + "img/img_gate01.1fe8bb6d.jpg";